import {
  CONFIG_KEYS_REQUEST,
  CONFIG_KEYS_SUCCESS,
  CONFIG_KEYS_FAILURE,
  CONFIGS_REQUEST,
  CONFIGS_SUCCESS,
  CONFIGS_FAILURE,
  UPDATE_CONFIG,
  ADD_CONFIG,
  DELETE_CONFIG,
  COPY_CONFIG,
  ADD_CONSTRAINT,
  DELETE_CONSTRAINT,
  CONFIGS_SAVE_REQUEST,
  CONFIGS_SAVE_FAILURE,
  CONFIGS_SAVE_SUCCESS,
  ACTIVE_CONFIG_REQUEST,
  ACTIVE_CONFIG_SUCCESS,
  ACTIVE_CONFIG_FAILURE,
  ACTIVATE_CONFIG_REQUEST,
  ACTIVATE_CONFIG_SUCCESS,
  ACTIVATE_CONFIG_FAILURE,
} from '../actions/configs';

import {
  LOGOUT_USER_REQUEST,
} from '../actions/user';

import { IMAGE_UPLOAD_SUCCESS } from '../actions/images';

const allKeys = (state = [], action) => {
  const { payload = {} } = action;
  const { keys } = payload;

  switch(action.type) {
    case CONFIG_KEYS_SUCCESS:
      return [...keys];
    case CONFIG_KEYS_FAILURE:
      return [];
    default:
      return state;
  }
};

const createConfig = (initialState = {}) => {
  return {
    weight: initialState.weight || 1,
    slot: initialState.slot || 0, // Defaults first position, ie slot 0
    tag: initialState.tag || '',
    link: initialState.link || '',
    image: initialState.image || '',
    header: initialState.header || '',
    body: initialState.body || '',
    button: initialState.button || '',
    constraint: initialState.constraint || [],
  };
};

const constraint = (state=[], action) => {
  const { payload = {} } = action;
  const { constraint, row, column } = payload;

  switch(action.type) {
    case ADD_CONSTRAINT:
      return [
        ...state.slice(0, row),
        [ ...state[row] || [], constraint ],
        ...state.slice(row + 1),
      ];
    case DELETE_CONSTRAINT:
      return state[row].length === 1 && column === 0 ? [
        ...state.slice(0, row),
        ...state.slice(row + 1),
      ] : [
        ...state.slice(0, row),
        [
          ...state[row].slice(0, column),
          ...state[row].slice(column + 1),
        ],
        ...state.slice(row + 1),
      ];
    default:
      return state;
  }
};

const byKey = (state = {}, action) => {
  const { payload = {} } = action;
  const { key, index, config, configs, error, url, items, slot } = payload;

  switch(action.type) {
    case CONFIGS_SUCCESS:
      return {
        ...state,
        [key]: {
          items: configs.items ? configs.items.map(configItem => createConfig(configItem)) : [],
          isSaved: true,
          isSaving: false,
          saveError: null,
        },
      };
    case CONFIGS_FAILURE:
      return {
        ...state,
        [key]: {
          ...state[key],
          items: [],
          isSaved: true,
          isSaving: false,
          saveError: null,
        },
      };
    case UPDATE_CONFIG:
      return {
        ...state,
        [key]: {
          ...state[key],
          items: [
            ...state[key].items.slice(0, index),
            { ...state[key].items[index], ...config },
            ...state[key].items.slice(index + 1),
          ],
          isSaved: false,
        },
      };
    case ADD_CONFIG:
      return {
        ...state,
        [key]: {
          ...state[key],
          items: [createConfig({ slot }), ...state[key].items],
          isSaved: false,
        },
      };
    case DELETE_CONFIG:
      return {
        ...state,
        [key]: {
          ...state[key],
          items: [
            ...state[key].items.slice(0, index),
            ...state[key].items.slice(index + 1),
          ],
          isSaved: false,
        },
      };
    case COPY_CONFIG:
      return {
        ...state,
        [key]: {
          ...state[key],
          items: [createConfig(config), ...state[key].items],
          isSaved: false,
        },
      };

    case ADD_CONSTRAINT:
    case DELETE_CONSTRAINT:
      return {
        ...state,
        [key]: {
          ...state[key],
          items: [
            ...state[key].items.slice(0, index),
            {
              ...state[key].items[index],
              constraint: constraint(state[key].items[index].constraint, action),
            },
            ...state[key].items.slice(index + 1),
          ],
          isSaved: false,
        },
      };
    case IMAGE_UPLOAD_SUCCESS:
      return {
        ...state,
        [key]: {
          ...state[key],
          items: [
            ...state[key].items.slice(0, index),
            { ...state[key].items[index], image: url },
            ...state[key].items.slice(index + 1),
          ],
        },
      };
    case CONFIGS_SAVE_REQUEST:
      return {
        ...state,
        [key]: {
          ...state[key],
          isSaved: false,
          isSaving: true,
        },
      };
    case CONFIGS_SAVE_FAILURE:
      return {
        ...state,
        [key]: {
          ...state[key],
          isSaving: false,
          saveError: error,
        },
      };
    case CONFIGS_SAVE_SUCCESS:
      return {
        ...state,
        [key]: {
          ...state[key],
          // Even if configs state typically is accurate when just saving, we
          // need to fill it in case we just created a new copy
          items: items.map(createConfig),

          isSaved: true,
          isSaving: false,
          saveError: null,
        },
      };
    default:
      return state;
  }
};

const initialState = {
  allKeys : [],
  byKey: {},
  activeKey: '',
  isFetchingKeys: false,
  isFetchingConfigs: false,
  fetchKeysError: null,
  fetchConfigsError: null,
  isFetchingActiveKey: false,
  fetchingActiveKeyError: null,
  isActivatingKey: false,
  activatingKeyError: null,
};

export default (state = initialState, action) => {
  const { payload = {} } = action;
  const { error, key } = payload;

  switch(action.type) {
    case CONFIGS_REQUEST:
      return {
        ...state,
        isFetchingConfigs: true,
        fetchConfigsError: null,
      };
    case CONFIGS_SUCCESS:
      return {
        ...state,
        byKey: byKey(state.byKey, action),
        isFetchingConfigs: false,
        fetchConfigsError: null,
      };
    case CONFIGS_FAILURE:
      return {
        ...state,
        byKey: byKey(state.byKey, action),
        isFetchingConfigs: false,
        fetchConfigsError: error,
      };
    case UPDATE_CONFIG:
    case ADD_CONFIG:
    case DELETE_CONFIG:
    case COPY_CONFIG:
    case ADD_CONSTRAINT:
    case DELETE_CONSTRAINT:
    case CONFIGS_SAVE_REQUEST:
    case CONFIGS_SAVE_FAILURE:
    case CONFIGS_SAVE_SUCCESS:
    case IMAGE_UPLOAD_SUCCESS:
      return {
        ...state,
        byKey: byKey(state.byKey, action),
      };
    case CONFIG_KEYS_REQUEST:
      return {
        ...state,
        isFetchingKeys: true,
        fetchKeysError: null,
      };
    case CONFIG_KEYS_SUCCESS:
      return {
        ...state,
        allKeys: allKeys(state.allKeys, action),
        isFetchingKeys: false,
        fetchKeysError: null,
      };
    case CONFIG_KEYS_FAILURE:
      return {
        ...state,
        allKeys: allKeys(state.allKeys, action),
        isFetchingKeys: false,
        fetchKeysError: error,
      };
    case ACTIVATE_CONFIG_REQUEST:
      return {
        ...state,
        isActivatingKey: true,
        activatingKeyError: null,
      };
    case ACTIVE_CONFIG_REQUEST: {
      return {
        ...state,
        isFetchingActiveKey: true,
        fetchingActiveKeyError: null,
      };
    }
    case ACTIVATE_CONFIG_FAILURE:
      return {
        ...state,
        isActivatingKey: false,
        activatingKeyError: error,
        activeKey: '',
      };
    case ACTIVE_CONFIG_FAILURE: {
      return {
        ...state,
        isFetchingActiveKey: true,
        fetchingActiveKeyError: error,
        activeKey: '',
      };
    }
    case ACTIVATE_CONFIG_SUCCESS:
      return {
        ...state,
        isActivatingKey: false,
        activatingKeyError: null,
        activeKey: key,
      };
    case ACTIVE_CONFIG_SUCCESS: {
      return {
        ...state,
        isFetchingActiveKey: false,
        fetchingActiveKeyError: null,
        activeKey: key,
      };
    }
    case LOGOUT_USER_REQUEST:
      return { ...initialState };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/configs.js